<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-content">
      <div class="modal-content-header">批量发送</div>
      <div class="modal-content-body">
        <div class="content-view">
          <div class="title">批量用户导入</div>
          <div class="btn-uploading" @click="handleFileUpload">点击选取待上传的文件</div>
          <div class="file-name" v-if="file">{{ file.name }}</div>
          <input class="file-input" ref="inputRef" type="file" accept=".xlsx" @change="sendFileInWeb" />
          <div class="explain">说明：请点击下载链接，获取 <span class="link" @click="onDownloadTemplateFn()">「批量用户导入」</span> 模板；正确填写完成后导入相关数据。</div>
        </div>

        <div class="input-outer">
          <textarea placeholder="请输入消息" v-model="message" placeholder-class="placeholder-class" maxlength="500"></textarea>
          <!-- 增加加载状态 -->
          <button @click="onSendFn()" :disabled="isLoading">发送</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, TOAST_TYPE } from '@/TUIKit/components/common/Toast';
import { batchSendC2cMsgApi } from '@/utils/user';
export default {
  name: 'BatchSendModal',
  data() {
    return {
      message: '',
      file: null,
      isLoading: false,
    };
  },
  mounted() {
    this.initFn();
  },
  methods: {
    initFn() {
      this.file = null;
      this.$refs.inputRef.value = '';
      this.message = '';
    },
    handleFileUpload() {
      this.$refs.inputRef.click();
    },
    sendFileInWeb(event) {
      const file = event.target.files[0];
      if (file) {
        this.file = file;
        console.log('this.file: ', this.file.name);
        event.target.value = '';
      }
    },
    onSendFn() {
      if (!this.message) {
        Toast({
          message: '请输入消息',
          type: TOAST_TYPE.ERROR,
        });
        return;
      } else if (!this.file) {
        Toast({
          message: '请上传文件',
          type: TOAST_TYPE.ERROR,
        });
        return;
      }

      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const nickName = userInfo.nickName || '';
      const cloudCustomData = nickName ? JSON.stringify({
        nickName: nickName || '',
      }) : '';

      // 创建FormData对象
      const formData = new FormData();
      formData.append('text', this.message);
      formData.append('file', this.file);
      formData.append('cloudCustomData', cloudCustomData);
      console.log('发送参数: ', formData);
      this.isLoading = true;
      batchSendC2cMsgApi(formData).then(res => {
        console.log('发送结果: ', res);
        if (res?.head?.st === 0) {
          this.$emit('close');
          Toast({
            message: '发送成功',
            type: TOAST_TYPE.SUCCESS,
          });
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    onDownloadTemplateFn() {
      window.open('https://mdstar.oss-cn-beijing.aliyuncs.com/backend/%E6%89%B9%E9%87%8F%E7%94%A8%E6%88%B7%E6%93%8D%E4%BD%9C.xlsx');
    },
  },
};
</script>

<style scoped lang="scss">
:not(not) {
  box-sizing: border-box;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .modal-content {
    background-color: white;
    padding: 18px 24px 40px 24px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 500px;
    text-align: center;

    .modal-content-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      color: #333;
    }

    .modal-content-body {
      border: 1px solid #D9D9D9;
      margin-top: 10px;

      .content-view {
        min-height: 194px;
        padding: 11px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title {
          font-size: 14px;
          color: #B26D9F;
          font-weight: 500;
        }
        .btn-uploading {
          padding: 2px 16px;
          margin-top: 10px;
          font-size: 14px;
          color: #4D7AFF;
          font-weight: 500;
          border: 1px solid #E3E3E3;
          border-radius: 4px;
          cursor: pointer;
        }
        .file-name {
          font-size: 12px;
          color: #333;
        }
        .file-input {
          display: none;
        }
        .explain {
          max-width: 410px;
          font-size: 12px;
          color: #666;
          margin-top: 10px;
          .link {
            color: #B26D9F;
            font-weight: 500;
            cursor: pointer;
          }
        }
      }

      .input-outer {
        padding-bottom: 40px;
        height: 174px;
        border-top: 1px solid #E3E3E3;
        position: relative;
        textarea {
          width: 100%;
          height: 100%;
          border: 0;
          border-radius: 4px;
          resize: none;
          padding: 10px;
          font-size: 12px;
          color: #333;
        }
        .placeholder-class {
          color: #C3C9CF;
          font-size: 12px;
        }
        button {
          position: absolute;
          right: 4px;
          bottom: 4px;
          border: none;
          font-size: 14px;
          color: #FFFFFF;
          font-weight: 500;
          background-color: #006EFF;
          border-radius: 4px;
          padding: 5px 16px;
        }
      }
    }
  }
}
</style> 